import Welcome from '@/components/Pages/Welcome.vue';
import AboutAccount from '@/components/Welcome/AboutAccount.vue';
import ContactInfo from '@/components/Welcome/ContactInfo.vue';
import Offers from '@/components/Welcome/Offers.vue';
import RouteNames from '../constants/route-names';

const route = {
  path: '/welcome',
  name: RouteNames.Welcome,
  component: Welcome,
  redirect: '/welcome/about-account',
  children: [
    {
      path: 'about-account',
      component: AboutAccount,
    },
    {
      path: 'contact-info',
      component: ContactInfo,
    },
    {
      path: 'offers',
      component: Offers,
    },
  ],
};

export default route;
